import { render, staticRenderFns } from "./NewFans.vue?vue&type=template&id=0d308c19&"
import script from "./NewFans.vue?vue&type=script&lang=js&"
export * from "./NewFans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports